import React, { useState } from 'react';

/* A member's photo, or their initial when there isn't one (or it fails to
   load). Keeps whatever circle class the caller already styles. */
export default function Avatar({ person, className = '', title }) {
  const [broken, setBroken] = useState(false);
  const url = person?.avatar_url;
  const initial = (person?.name || '?')[0];
  return (
    <span className={`${className} av${url && !broken ? ' has-photo' : ''}`} title={title}>
      {url && !broken
        ? <img className="av-img" src={url} alt="" loading="lazy" onError={() => setBroken(true)} />
        : initial}
    </span>
  );
}
